module.exports = __webpack_public_path__ + "media/assets/icons/time-9873b0f8360ec32ee105762f19fdc2b3.svg";